import React from 'react';
import PropTypes from 'prop-types';
import cellStyles from './click-cell.scss';

class ClickCell extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const { onClick, children } = this.props;
    return (
      <td
        className={cellStyles.clickCell}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' ? onClick() : null)}
      >
        {children}
      </td>
    );
  }
}

export default ClickCell;
